var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-wrap mr-3 mb-3"},[_c('a',{staticClass:"badge badge-warning",attrs:{"href":_vm.computedHref}},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }